import { SupportedSalesOrganisation } from './enums'

/**
 * Maps sales organization codes to customer service email addresses.
 * Used for Contact Us mailto links throughout the application.
 * BCA-584: Added as replacement for FreshChat widget
 */
export const salesOrgToEmailMapping: Record<string, string> = {
  // Australia
  [SupportedSalesOrganisation.Australia]: 'orders.au@brenntag-asia.com',
  // New Zealand
  [SupportedSalesOrganisation.NewZealand]: 'brenntagnz@brenntag-asia.com',
  // Singapore
  [SupportedSalesOrganisation.Singapore]: 'cs-sin@brenntag-asia.com',
  // Malaysia
  [SupportedSalesOrganisation.Malaysia]: 'mycs@brenntag-asia.com',
  // Indonesia
  [SupportedSalesOrganisation.Indonesia]: 'idcustomercare@brenntag-asia.com',
  // India (also covers Sri Lanka and Nepal)
  [SupportedSalesOrganisation.India]: 'in.cs@brenntag-asia.com',
  // Thailand
  [SupportedSalesOrganisation.ThailandBIT]: 'allthMST@brenntag-asia.com',
  [SupportedSalesOrganisation.ThailandTD]: 'allthMST@brenntag-asia.com',
  // Vietnam (Brenntag only - Nam Giang excluded per requirements)
  [SupportedSalesOrganisation.VietnamBrenntag]:
    'vn.btconnect@brenntag-asia.com',
  // Philippines
  [SupportedSalesOrganisation.Philippines]: 'ph.cs@brenntag-asia.com',
  // Korea
  [SupportedSalesOrganisation.Korea]: 'kr.cs@brenntag-asia.com',
  // Taiwan
  [SupportedSalesOrganisation.Taiwan]: 'tw.cs@brenntag-asia.com',
}

// Default fallback email
const DEFAULT_CONTACT_EMAIL = 'orders.au@brenntag-asia.com'

/**
 * Gets the customer service email address for a given sales organization.
 * Falls back to Australia email if sales org is not found.
 */
export const getContactEmailBySalesOrg = (
  salesOrg: string | undefined,
): string => {
  if (!salesOrg) return DEFAULT_CONTACT_EMAIL
  return salesOrgToEmailMapping[salesOrg] || DEFAULT_CONTACT_EMAIL
}

/**
 * Generates a mailto URL for the Contact Us link.
 */
export const getContactUsMailtoLink = (salesOrg: string | undefined): string =>
  `mailto:${getContactEmailBySalesOrg(salesOrg)}`
